import React  from 'react';
import Button from 'components/Utilities/Button';

export default function ButtonNext(props)
{
  const { children, onClick, withIcon } = props;

  const icons = withIcon ?
    (
      <>
        <span className="ion-chevron-right"></span>
        <span className="ion-chevron-right"></span>
      </>
    ) :
    null

  const label = children || 'Next';

  return (
    <Button onClick={onClick}>
      {label}{icons}
    </Button>
  )
}
